import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { RootState } from '../../../../store/store'
import { useCallback, useEffect, useState } from 'react'
import { TRANSPORT_ROUTE } from '../../../../common/utils/constants'
import { addNotification } from '../../../../store/slices/notificationSlice'
import { v4 } from 'uuid'
import { Group, NotificationTypes } from '../../../../common/types/enums'
import { getApi } from '../../../../api/api'
import { TransportItemInterface } from '../../../../common/types/interfaces'
import {
  selectTransportItem,
  selectTransportList,
} from '../../../../store/slices/transportListSlice'
import { selectCurrentUser } from '../../../../store/slices/currentUserSlice'

export const useTransportItem = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const currentUser = useSelector(selectCurrentUser)
  const [api] = useState(getApi())
  const [item, setItem] = useState<TransportItemInterface>()
  const itemState = useSelector((state: RootState) => selectTransportItem(state, Number(id)))
  const transportList = useSelector(selectTransportList)

  
  const getItem = useCallback(async () => {
    try {
      let result: TransportItemInterface
      if (currentUser) {
        result = await api.getTransport(Number(id))
      } else {
        result = await api.getAdTransport(Number(id))
      }

      if (result) {
        setItem(result)
        window.scrollTo(0, 0)
        return
      }
      dispatch(
        addNotification({
          id: v4(),
          type: NotificationTypes.ERROR,
          text: 'Транспорт не найден.',
        }),
      )
      navigate(TRANSPORT_ROUTE)
    } catch (error) {
      dispatch(
        addNotification({
          id: v4(),
          type: NotificationTypes.ERROR,
          text: 'Транспорт не найден.',
        }),
      )
      navigate(TRANSPORT_ROUTE)
    }
  }, [api, dispatch, id, navigate, currentUser])

  const addView = useCallback(
    async (el: TransportItemInterface) => {
      try {
        if (currentUser && currentUser.id && el.id && el.userId !== currentUser.id) {
          await api.addView({ el_id: el.id }, Group.TRANSPORT)
          await getItem()
        }
      } catch (error) {}
    },
    [api, currentUser, getItem],
  )

  const toggleSelected = useCallback(
    async (item: TransportItemInterface) => {
      try {

        const id = item.selected?.find((el: any) => el.user_id === currentUser?.id)?.id
        
        
        if (item && id) {
          await api.deleteSelected({ id }, Group.TRANSPORT)
        } else if (item.id) {
          await api.addSelected({ el_id: item.id }, Group.TRANSPORT)
        }
        await getItem()
      } catch (error) {
        
      }
    },
    [api, currentUser?.id, getItem],
  )

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    // if (itemState) {
    //   setItem(itemState)
    //   return
    // }
    getItem()
  }, [api, itemState])

  useEffect(() => {
    if (itemState) addView(itemState)
  }, [itemState])

  useEffect(() => {
    if (item?.id && !transportList.data.find((el) => el.id === item?.id)) navigate(-1)
  }, [transportList, item?.id])

  return { item, toggleSelected }
}
